import { api } from "@/api";

export const deleteBettingMarket = async (id: number): Promise<void> => {
  await api.client.delete(`/betting-markets-new/${id}`);
};
